import PayorProviderCredentialRow from '../../../components/PayorProviderCredentialRow';

import type { ProviderPayorCredentialItemProps } from '../types';

export function ProviderPayorCredentialItem({
  credential,
  index,
  isAdding,
  isEditing,
  isDisabled,
  onEdit,
  onCancel,
  onSave,
  onDelete,
}: ProviderPayorCredentialItemProps) {
  const handleEdit = () => {
    onEdit(index);
  };

  return (
    <PayorProviderCredentialRow
      payorProviderCredential={credential}
      isAdding={isAdding}
      isEditing={isEditing}
      isDisabled={isDisabled}
      onEdit={handleEdit}
      onCancel={onCancel}
      onSave={onSave}
      onDelete={onDelete}
    />
  );
}
